import { Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';
import { NavbarButton } from '~frontend-common/components/base-navbar';
import { ExternalLink } from '~frontend-common/components/ui';
import { useTranslator } from '~frontend-common/i18n/translator';
import { QuestionMarkCircleIcon } from '~ui-kit/components/icons/question-mark-circle-icon';
import { Links } from '~web-portal/variables/links';

export function NavbarHelpMenu() {
  const translator = useTranslator();
  const { tl } = translator;
  const langId = translator.getCurrentLanguageId();

  const [helpMenuAnchorEl, setHelpMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenHelpMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setHelpMenuAnchorEl(event.currentTarget);
  };

  const handleCloseHelpMenu = () => {
    setHelpMenuAnchorEl(null);
  };

  return (
    <>
      <NavbarButton
        icon={<QuestionMarkCircleIcon />}
        onClick={handleOpenHelpMenu}
        tooltip={tl('ui.navbar.tooltip.helpMenu')}
      />

      <Menu
        id="navbar-help-menu"
        anchorEl={helpMenuAnchorEl}
        keepMounted
        open={Boolean(helpMenuAnchorEl)}
        onClose={handleCloseHelpMenu}
      >
        <ExternalLink href={Links.pages[langId].helpCenter} openNewTab color="inherit" colorHover="inherit">
          <MenuItem onClick={handleCloseHelpMenu}>{tl('ui.navbar.menu.helpCenter')}</MenuItem>
        </ExternalLink>
        <ExternalLink href={Links.pages[langId].contactUs} openNewTab color="inherit" colorHover="inherit">
          <MenuItem onClick={handleCloseHelpMenu}>{tl('ui.navbar.menu.contactUs')}</MenuItem>
        </ExternalLink>
      </Menu>
    </>
  );
}
